import React from "react";
import styled from "styled-components";
import { FaFingerprint, FaGift, FaPlay } from "react-icons/fa";

const About = () => {
  return (
    <Wrapper>
      <section className="about-section" style={{ marginTop: "70px" }}>
        <div className="rs-section-title-wrapper">
          <span className="rs-section-subtitle has-theme-orange justify-content-center">
            <FaPlay color="#EA5501" size={12} />
            About Us
          </span>
        </div>

        <div className="container shadow py-4">
          <div className="row g-0">
            {/* Left Image */}
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="video-box">
                <img
                  src="/assets/images/about/about-11.jpg"
                  alt="About"
                  className="img-fluid w-100"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6 col-md-12 col-sm-12 d-flex align-items-center">
              <div className="about-content">
                <div className="section-title">
                  <h2>About Us</h2>

                  <p>
                    Eque Spinning & Composite Ltd. is the leading manufacturer
                    of Net & Twine products in Bangladesh. With over 10 years of
                    experience, we are now producing more than 50 types of
                    netting & twine products using German and Japanese
                    Technology & machinery. We are also the largest manufacturer
                    of plastic mats and soft shell crabs in Bangladesh.
                  </p>
                </div>

                {/* Item 1 */}
                <div className="icon-box">
                  {/* <div className="icon">
                    <i className="bx bx-fingerprint text-white"></i>
                  </div> */}
                  <div className="icon">
                    <FaFingerprint />
                  </div>

                  <div className="content">
                    <h4>NET'S</h4>

                    <p>
                      We produce high strength Nylon/Polyester multifilament
                      fishing net. These nets can be customized as per buyer's
                      requirements and available in non-slip single or double
                      knot.
                    </p>
                  </div>
                </div>

                {/* Item 2 */}
                <div className="icon-box">
                  {/* <div className="icon">
                    <i className="bx bx-gift text-white"></i>
                  </div> */}
                  <div className="icon">
                    <FaGift />
                  </div>

                  <div className="content">
                    <h4>GARMENTS ACCESSORIES</h4>

                    <p>
                      We produce all kinds of twill tapes, Grosgrain tapes,
                      Hanger loops, Satin ribbon, Elastics (Plain & woven),
                      Printed fabric label (PFL), and Gum tape.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .about-section {
    /* background: #fff; */
  }

  .video-box {
    overflow: hidden;
    height: 100%;
  }

  .video-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .about-content {
    padding: 40px;
  }

  .section-title h2 {
    font-size: 34px;
    font-weight: 700;
    color: #1f1f1f;
    margin-bottom: 20px;
    position: relative;
  }

  .section-title h2::after {
    content: "";
    display: block;
    width: 60px;
    height: 3px;
    background: #ea5501;
    margin-top: 10px;
  }

  .section-title p {
    color: #666;
    font-size: 15px;
    line-height: 28px;
    margin-bottom: 35px;
  }

  .icon-box {
    display: flex;
    align-items: flex-start;
    margin-bottom: 35px;
  }

  .icon {
    width: 70px;
    height: 70px;
    background: #ea5501;
    color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    flex-shrink: 0;
    margin-right: 20px;
  }

  .content h4 {
    font-size: 20px;
    font-weight: 700;
    color: #222;
    margin-bottom: 10px;
  }

  .content h4:hover {
    color: #ea5501;
    cursor: pointer;
  }

  .content p {
    margin: 0;
    color: #666;
    line-height: 27px;
    font-size: 15px;
  }

  /* Responsive */

  @media (max-width: 991px) {
    .about-content {
      padding: 30px 15px;
    }

    .icon {
      width: 60px;
      height: 60px;
      font-size: 26px;
    }

    .content h4 {
      font-size: 18px;
    }

    .section-title h2 {
      font-size: 28px;
    }
  }
`;

export default About;
